export default __webpack_public_path__ + "static/media/key.1659f78b.svg";